import React, { useEffect, useState, useRef } from "react";
import { Tabs, Card, Row, Typography, Col, Spin } from "antd";
import { BASE_URL } from "../Components/Constant";
import ApiService from "../Components/apiService";
import CompactLayout from "../Record/CompactLayoutDisplay";
import MyTask from "../HomeDashboard/MyTask";
import ApprovalDashboard from "../HomeDashboard/ApprovalDashboard";
import ActivityComponent from "../Activity/ActivityComponent";
import RelatedList from "./RelatedList";
import RecordDetails from "../Record/RecordDetail";
import eventBus from "../Components/eventBus";
import ApprovalTab from "../ApprovalRequest/ApprovalRecordTab";
import RelatedRecord from "../Record/RelatedRecords";
import Feed from "../CommentFeed/Feed";
import { useSelector } from "react-redux";
import RecordPath from "../Record/RecordPath";
import RecordAlerts from "../Record/RecordAlerts";
const { TabPane } = Tabs;
const { Title } = Typography;
const isGrid = true;

const RenderStandardComponent = ({
  picklistFieldNameForRecordPath,
  updateStatus,
  picklistValues,
  selectedIndex,
  currentSelectedValue,
  completeStep,
  setSelectedIndex,
  isValueUpdated,
  cancelSelectedValue,
  component,
  recordId,
  objectName,
  functionRef,
  metadata,
  overallLoading = false,
  record,
  fetchRecords,
  setRecord,
  tableProperties,
  getRowStyle,
  alerts,
}) => {
  // const [loading, setLoading] = useState(true);
  const security = useSelector((state) => state.data.items[0]);
  const [activeCurrencies, setActiveCurrencies] = useState([]);
  const TabHeight = "100vh";

  useEffect(() => {
    console.log("picklistValues :: ", picklistValues);
  }, [picklistValues]);

  useEffect(() => {
    eventBus.on("RecordSaved", fetchRecords);

    return () => {
      eventBus.off("RecordSaved", fetchRecords); // Cleanup listener
    };
  }, []);

  const fetchCurrency = async () => {
    try {
      const apiService = new ApiService(
        `${BASE_URL}/mt_currencies`,
        {
          "Content-Type": "application/json",
        },
        "GET",
      );
      const response = await apiService.makeCall();
      setActiveCurrencies(response);
    } catch (err) {
      console.error("Error fetching metadata:", err);
    }
  };
  const getConvertedValue = (amount, fromCode, toCode) => {
    const parsedAmount = parseFloat(amount);

    // Check for invalid or empty amount
    if (isNaN(parsedAmount) || fromCode === toCode) {
      return isNaN(parsedAmount) ? "0.00" : parsedAmount.toFixed(2);
    }

    const fromCurrency = activeCurrencies.find((c) => c.iso_code === fromCode);
    const toCurrency = activeCurrencies.find((c) => c.iso_code === toCode);

    if (
      !fromCurrency ||
      !toCurrency ||
      !fromCurrency.conversion_rate ||
      !toCurrency.conversion_rate
    ) {
      return "0.00";
    }

    const inCorporate = parsedAmount / fromCurrency.conversion_rate;
    const converted = inCorporate * toCurrency.conversion_rate;

    return converted.toFixed(2);
  };

  switch (component.selectedComponentName) {
    case "ApprovalDashboard":
      return <ApprovalDashboard />;
    case "MyTasks":
      return <MyTask />;
    case "Activity":
      return (
        <div
          className="rdg-light"
          style={{ maxHeight: "470px", overflowY: "auto" }}
        >
          {scrollStyle}
          <Card style={{ marginTop: "2px", marginLeft: 0, marginRight: 0 }}>
            <Row justify="space-between" align="middle">
              <Col>
                <Title level={4} style={{ marginBottom: 8 }}>
                  Activity Timeline
                </Title>
              </Col>
            </Row>
            <ActivityComponent objectName={objectName} recordId={recordId} />
          </Card>
        </div>
      );
    case "relatedLists":
      return (
        <RelatedList
          recordId={recordId}
          objectName={objectName}
          component={component}
          record={record}
          metadata={metadata}
          tableProperties={tableProperties}
          getRowStyle={getRowStyle}
        />
      );
    case "CompactLayout":
      return (
        <CompactLayout
          setFunctionRef={(fn) => (functionRef.current = fn)}
          fetchCurrency={fetchCurrency}
          getConvertedValue={getConvertedValue}
          actionButtons={metadata?.actionButtons}
          id={recordId}
          objName={objectName}
          compactlayout={metadata?.compactLayout}
          record={record}
          fields={metadata?.fields}
          recordPathField={metadata?.recordPathField}
          picklistValues={metadata?.picklistValues}
          allowApprovals={metadata?.allowApprovals}
          allowActivity={metadata?.allowActivity}
        />
      );
    case "RecordDetails":
      return (
        <RecordDetails
          fetchCurrency={fetchCurrency}
          getConvertedValue={getConvertedValue}
          objectName={objectName}
          id={recordId}
          fetchRecordData={fetchRecords}
          recordDetails={record}
          Recordfields={metadata?.fields}
          layout={metadata?.layout}
        />
      );
    case "RecordPath":
      if (!picklistValues?.length) {
        return (
          <div style={{ padding: 20 }}>
            Record Path field or picklist values not configured.
          </div>
        );
      }
      return (
        <RecordPath
          picklistValues={picklistValues ?? []}
          currentStatus={currentSelectedValue}
          completeStep={completeStep}
          setSelectedIndex={setSelectedIndex}
          selectedIndex={selectedIndex}
          isValueUpdated={isValueUpdated}
          cancelSelectedValue={cancelSelectedValue}
          updateStatus={updateStatus}
          objectName={objectName}
          fieldName={picklistFieldNameForRecordPath}
        />
      );

    case "RecordDetailTabs":
      return (
        <>
          <Spin spinning={overallLoading} size="medium">
            <div
              style={{
                backgroundColor: "white",
                borderRadius: 7,
                padding: 10,
                border: "1px solid rgb(239, 239, 239)",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              }}
            >
              <Tabs defaultActiveKey="1" style={{ marginLeft: 5 }}>
                <TabPane
                  tab="Detail"
                  key="1"
                  style={{
                    maxHeight: TabHeight,
                    overflowY: "auto",
                  }}
                >
                  {record && Object.keys(record).length > 0 && (
                    <RecordDetails
                      fetchCurrency={fetchCurrency}
                      getConvertedValue={getConvertedValue}
                      objectName={objectName}
                      id={recordId}
                      fetchRecordData={fetchRecords}
                      recordDetails={record}
                      Recordfields={metadata?.fields}
                      layout={metadata?.layout}
                      isGrid={isGrid}
                    />
                  )}
                </TabPane>

                <TabPane
                  tab="Related"
                  key="2"
                  style={{
                    maxHeight: TabHeight,
                    overflowY: "auto",
                  }}
                >
                  <div
                    className="rdg-light"
                    style={{ maxHeight: TabHeight, overflowY: "auto" }}
                  >
                    {scrollStyle}
                    <RelatedRecord
                      recordDetails={record}
                      objectName={objectName}
                      recordId={recordId}
                      metadata={metadata}
                    />
                  </div>
                </TabPane>
                {metadata?.allowActivity &&
                  security?.object_settings?.["Activity"]?.object_setting
                    ?.view === true && (
                    <TabPane
                      tab="Activity"
                      key="3"
                      style={{
                        maxHeight: TabHeight,
                        overflowY: "auto",
                      }}
                    >
                      <ActivityComponent
                        objectName={objectName}
                        recordId={recordId}
                      />
                    </TabPane>
                  )}
                {metadata?.allowApprovals && (
                  <TabPane
                    tab="Approvals"
                    key="4"
                    style={{
                      maxHeight: TabHeight,
                      overflowY: "auto",
                    }}
                  >
                    <ApprovalTab
                      functionRef={functionRef.current}
                      object={objectName}
                      recordId={recordId}
                      setRecordData={setRecord}
                      fetchRecordData={fetchRecords}
                    />
                  </TabPane>
                )}
              </Tabs>
            </div>
          </Spin>
        </>
      );

    case "Comments":
      return (
        <Feed
          objectName={objectName}
          recordId={recordId}
          metadata={metadata}
        ></Feed>
      );

    case "Alerts":
      return (
        <RecordAlerts
          objectName={objectName}
          recordId={recordId}
          metadata={metadata}
          alerts={alerts}
        ></RecordAlerts>
      );

    default:
      return <div>Component</div>;
  }
};

const scrollStyle = (
  <style jsx>{`
    .rdg-light {
      position: relative;
      overflow: auto;
    }

    .rdg-light:hover::-webkit-scrollbar {
      width: 6px; /* Makes the scrollbar thin */
      height: 6px; /* Optional for horizontal scrollbar */
    }

    .rdg-light::-webkit-scrollbar {
      width: 0px; /* Initially make scrollbar invisible */
      height: 0px; /* Optional for horizontal scrollbar */
    }

    .rdg-light::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.3);
      border-radius: 3px;
    }

    .rdg-light::-webkit-scrollbar-track {
      background: transparent;
    }
  `}</style>
);

export default RenderStandardComponent;
